import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { Calendar, Clock, User, ArrowRight } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
export function BlogListingPage() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-429">
      <Helmet data-id="element-430">
        <title data-id="element-431">Blog | I75 Audio & Video</title>
        <meta name="description" content="Read the latest news, tips, and insights about home theater, smart home technology, and audio/video solutions from I75 Audio & Video." data-id="element-432" />
      </Helmet>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20 mt-16" data-id="element-433">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-434">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-435">Our Blog</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-436">
            Expert insights, tips, and guides for your home entertainment and
            smart technology needs.
          </p>
        </div>
      </div>

      {/* Blog Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-437">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-438">
          {blogPosts.map(post => <article key={post.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-439">
              <div className="p-6 flex flex-col flex-grow" data-id="element-440">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-id="element-441">
                  <div className="flex items-center gap-1" data-id="element-442">
                    <Calendar size={14} data-id="element-443" />
                    <span data-id="element-444">{post.date}</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-445">
                    <Clock size={14} data-id="element-446" />
                    <span data-id="element-447">{post.readTime}</span>
                  </div>
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-448">
                  <Link to={`/blog/${post.slug}`} className="hover:text-blue-600 transition-colors" data-id="element-449">
                    {post.title}
                  </Link>
                </h2>

                <p className="text-gray-600 mb-6 line-clamp-3 flex-grow" data-id="element-450">
                  {post.excerpt}
                </p>

                <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-451">
                  <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-452">
                    <User size={14} data-id="element-453" />
                    <span data-id="element-454">{post.author}</span>
                  </div>
                  <Link to={`/blog/${post.slug}`} className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 text-sm" data-id="element-455">
                    Read More <ArrowRight size={16} className="ml-1" data-id="element-456" />
                  </Link>
                </div>
              </div>
            </article>)}
        </div>
      </div>

      <Footer data-id="element-457" />
    </div>;
}